import { render, staticRenderFns } from "./AIpromptWords.vue?vue&type=template&id=2221fb77&scoped=true"
import script from "./AIpromptWords.vue?vue&type=script&lang=js"
export * from "./AIpromptWords.vue?vue&type=script&lang=js"
import style0 from "./AIpromptWords.vue?vue&type=style&index=0&id=2221fb77&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221fb77",
  null
  
)

export default component.exports